import RestaurantSource from '../../data/restaurant-source'
import { sectionHeroTemplate, restaurantItemTemplate, SkeletonRestaurantTemplate } from '../templates/template-creator'

const WhyCulinaria = {
  async render () {
    return `
      <section id="hero" class="app-hero-container"></section>
      <div id="restaurantContent" class="content">
        <h2 class="content__heading">Explore The Restaurants</h2>
        <div id="restaurants" class="restaurants">
          ${SkeletonRestaurantTemplate(20)}
        </div>
      </div>
    `
  },

  async afterRender () {
    const test = document.querySelector('.test')
    test.style.height = 0

    const heroContainer = document.querySelector('#hero')
    heroContainer.innerHTML = sectionHeroTemplate()

    const loader = document.querySelector('.backdrop')
    loader.style.display = 'none'

    const restaurants = await RestaurantSource.home()
    const restaurantContainer = document.querySelector('#restaurants')
    restaurantContainer.innerHTML = ''
    restaurants.forEach((restaurant) => {
      restaurantContainer.innerHTML += restaurantItemTemplate(restaurant)
    })
  }
}

export default WhyCulinaria
